import { observable, action } from 'mobx';
import tim from '../public/js/tim';

class LiveMessageList {
  @observable currentMessageList = [] // 历史消息列表

  @observable nextReqMessageID = '' // 用于续拉，分页续拉时需传入该字段。

  @observable conversationID = '' // 会话ID。

  @observable preScrollHeight = 0 // 可视高度

  @observable endLive = true // 结束直播

  @observable livePerson = 0 // 直播在线人数

  /**
   * 获取消息列表
   * 调用时机：打开某一会话时或下拉获取历史消息时
   * @param {Object} context
   * @param {String} conversationID
   */
  @action getMessageLists = async (messagesEnd) => {
    const {
      data: { isCompleted, messageList },
    } = await tim.getMessageList({ conversationID: this.conversationID, count: 20 });
    this.isCompleted = isCompleted;
    this.currentMessageList = [...messageList];
    if (messagesEnd) {
      const { scrollHeight } = messagesEnd; // 里面div的实际高度
      // messagesEnd.scrollTop = 0
      this.preScrollHeight = scrollHeight;
    }
  }

  /**
   * 将消息插入当前会话列表
   * 调用时机：收/发消息事件触发时
   * @param {Object} state
   * @param {Message[]|Message} data
   * @returns
   */
  @action pushCurrentMessageList = (data) => {
    if (Array.isArray(data)) this.currentMessageList = [...this.currentMessageList, ...data];
    else this.currentMessageList = [...this.currentMessageList, data];
  }

  @action emptyCurrentMessageList = () => {
    this.currentMessageList = [];
  }

  /**
   * 获取设置群聊会话ID
   */
  @action setConversationID = (conversationID) => {
    this.conversationID = `GROUP${conversationID}`;
  }

  /**
   * 设置结束直播标志
   */
  @action setEndLive = (endLive) => {
    this.endLive = endLive;
  }

  /**
   * 设置在线人数
   */
  @action setLivePerson = (livePerson) => {
    this.livePerson = livePerson;
  }
}

export default new LiveMessageList();
